import { render } from "./returngenerationtrend.vue?vue&type=template&id=5d9d0edb"
import script from "./returngenerationtrend.vue?vue&type=script&lang=js"
export * from "./returngenerationtrend.vue?vue&type=script&lang=js"

import "./returngenerationtrend.vue?vue&type=style&index=0&id=5d9d0edb&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__